import React from "react";
import { Box, Flex, Image, Spacer, Text } from "@chakra-ui/react";
import { FaCode, FaGit, FaUser } from "react-icons/fa";
import "./about.css";
import ayushiImg from "../images/profile.png";
import { RiLightbulbFlashLine } from "react-icons/ri";
import { BiUserVoice } from "react-icons/bi";
import { VscGraph } from "react-icons/vsc";
// import LightSpeed from "react-reveal/LightSpeed";
// import styles from "./about.css";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";

export default function About() {
  return (
    <Box bg={"#040724"} className="about section" id="about">
      <Box
        w="95%"
        m="auto"
        bgColor={"#040724"}
        display={["inline", "inline", "inline", "flex", "flex"]}
        justifyContent="space-between"
        alignItems="center"
      >
        <Image
          margin={"auto"}
          bgColor={"#040724"}
          w={["50%", "40%", "55%", "28%", "28%"]}
          marginTop={"40px"}
          borderRadius={"16%"}
          className="home-img"
          boxShadow="orange 0px 5px 15px"
          p="5px"
          rounded={["50%", "50%", "50%", "50%", "50%"]}
          src={ayushiImg}
          alt="img"
        />
        <Box w={["95%", "95%", "95%", "50%", "45%"]} m="auto">
          <Box
            display={"flex"}
            gap={"19px"}
            align={"center"}
            justifyContent={"center"}
          >
            <Text
              textAlign="center"
              fontWeight="400"
              fontSize={["30px", "4xl", "7xl", "4xl", "5xl"]}
              color={"#00b9e8"}
              mt={["40px", "40px", "40px", "", ""]}
            >
              About Me
            </Text>
            <Text
              fontSize={["30px", "4xl", "7xl", "4xl", "5xl"]}
              marginTop={"45px"}
            >
              <FaUser className="bounce" color="#00b9e8" />
            </Text>
          </Box>
          <Text
            fontFamily="Geneva"
            mt={["7px", "4px", "10px"]}
            fontSize={["15px", "20px", "25px", "15px", "20px"]}
            textAlign={"justify"}
            alignContent={"center"}
            justifyContent={"center"}
            border={"0px solid white"}
            m={"auto"}
          >
            {/* <LightSpeed right big> */}
            {/* <LightSpeed right big> */}
            <Text
              color={"orange"}
              lineHeight={"38px"}
              id="user-detail-intro"
              alignContent={"center"}
              justifyContent={"center"}
            >
              {/* Confident, hardworking, and highly ambitious full-stack web developer, having good knowledge of Advance JavaScript, HTML, CSS, React, Redux, TypeScript, NodeJS, ExpressJS, MongoDB and Chakra UI. Have build individual and collaborative projects. Having a keen interest to learn new things and able to solve the problems. Looking forward to work in an environment where skills can be more enhanced. */}
              Confident, hardworking, and highly ambitious full-stack web
              developer, with good knowledge of advanced JavaScript, HTML, CSS,
              React, Redux, TypeScript, Node.js, Express.js, MongoDB, and Chakra
              UI. I have built individual and collaborative projects and have a
              keen interest in learning new things and solving problems. I am
              looking forward to working in an environment where I can enhance
              my skills further.
            </Text>
            {/* </LightSpeed> */}
          </Text>
          <br />
          <br />
          {/* <Center > */}
          <Flex
            w={["90%", "90%", "90%", "90%", "87%"]}
            m={"auto"}
            justifyContent="space-between"
            gap={3}
            alignContent={"center"}
            color={"orange"}
            fontSize={["9px", "9px", "20px", "10px", "15px"]}
          >
            <Box>
              {" "}
              <Flex className="texts" alignItems="center">
                <FaCode size="30px" />{" "}
                <Text ml={5}>1200+ Hours Practical Coding</Text>
              </Flex>
              <Flex className="texts" mt={5} alignItems="center">
                <RiLightbulbFlashLine size="30px" />{" "}
                <Text ml={5}>300+ Hours Data Structures & Algorithms</Text>
              </Flex>
              <Flex className="texts" mt={5} alignItems="center">
                <BiUserVoice size="30px" />{" "}
                <Text ml={5}>100+ Hours Soft Skill Development</Text>
              </Flex>
            </Box>
            <Spacer />

            <Box>
              {" "}
              <Flex className="texts" alignItems="center">
                <AiOutlineFundProjectionScreen size="30px" />{" "}
                <Text ml={3}>5+ Projects</Text>
              </Flex>
              <Flex className="texts" mt={5} alignItems="center">
                <VscGraph size="30px" /> <Text ml={3}>4+ Mini Projects</Text>
              </Flex>
              <Flex className="texts" mt={5} alignItems="center">
                <FaGit size="30px" /> <Text ml={3}>300+ Git Commits</Text>
              </Flex>
            </Box>
          </Flex>
          {/* // </Center> */}
        </Box>
      </Box>
    </Box>
  );
}
